import base from '../dr-base'
import drTreeView from './dr-tree-view.vue'
import drBaseActions from '../dr-base-actions'

const schema = {
  $Type: 'dr-tree-view',
  name: 'Tree view',
  group: 'Menu widgets',
  icon: 'folder-tree',
  ...base,
  properties: {
    ...base.properties,
    Items: {
      name: 'vuetifyWidgets.dr-tree-view.treeElements',
      type: 'string',
      default: ''
    },
    ShowIcons: {
      name: 'vuetifyWidgets.dr-tree-view.showIcons',
      type: 'boolean',
      default: false
    },
    Activatable: {
      name: 'vuetifyWidgets.dr-tree-view.activateOnClick',
      type: 'boolean',
      default: false
    },
    OnClickAction: {
      name: 'vuetifyWidgets.dr-button.onClickAction',
      type: 'object',
      component: 'dr-prop-action',
      properties: { 
        ...drBaseActions.properties.OnClickAction.properties,
        Type: {
          name: 'vuetifyWidgets.dr-button.type',
          type: 'string',
          enum: [
            ...drBaseActions.properties.OnClickAction.properties.Type.enum
          ]
        } 
      }
    }
  }
}

export default {
  schema,
  component: drTreeView,
  propEditors: [
    {
      name: 'dr-prop-action'
    }
  ]
}